import { useCallback } from 'react';
import { useCampaignEditorContext } from 'sections/onsite-campaigns/pages/CampaignEditor/contexts/CampaignEditorContext';

export const useUpdateBranch = () => {
  const { dispatch } = useCampaignEditorContext();

  return useCallback(
    (id: string, name: string) => {
      dispatch({
        type: 'UPDATE_BRANCH',
        payload: {
          id,
          name,
        },
      });
    },
    [dispatch],
  );
};
